<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import style from '@/styles/main.sass'
import {defineComponent} from "vue";
export default defineComponent({
  name: "app"
})
</script>
<style lang="scss">

</style>
